module.exports = __webpack_public_path__ + "static/media/DSC_0142-2.15b4f1a7.jpg";